import { useTheme } from '@admiin-com/ds-web';
import React from 'react';
import AdmiinLogo from '../../../assets/icons/admiin.svg';
import VisaIcon from '../../../assets/icons/visa.svg';
import MasterIcon from '../../../assets/icons/mastercard.svg';
import AmexIcon from '../../../assets/icons/amex.svg';
import PayToIcon from '../../../assets/icons/payTo.svg';
import PayToIconWhite from '../../../assets/icons/payToWhite.svg';
import AddBank from '../../../assets/icons/addBank.svg';
import AddBankWhite from '../../../assets/icons/addBankWhite.svg';
import AddCard from '../../../assets/icons/addCard.svg';
import AddCardWhite from '../../../assets/icons/add-card-white.svg';
import LoadSvgIcon from '../../component/LoadSvgIcon/LoadSvgIcon';

export interface CreditCardIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, 'type'> {
  type?: null | string;
}

export function CreditCardIcon({ type, width, height }: CreditCardIconProps) {
  const props: { width?: number | string; height?: number | string } = {};
  if (width) props.width = width;
  if (height) props.height = height;

  const theme = useTheme().palette.mode;

  if (type === 'visa')
    return (
      <LoadSvgIcon
        component={VisaIcon}
        {...props}
        fill={theme === 'dark' ? 'white' : 'black'}
      />
    );
  else if (type === 'mastercard')
    return (
      <LoadSvgIcon
        component={MasterIcon}
        {...props}
        fill={theme === 'dark' ? 'white' : 'black'}
      />
    );
  else if (type === 'american_express')
    return (
      <LoadSvgIcon
        component={AmexIcon}
        {...props}
        fill={theme === 'dark' ? 'white' : 'black'}
      />
    );
  else if (type === 'PAYTO') {
    if (theme === 'dark') {
      return <LoadSvgIcon component={PayToIconWhite} {...props} />;
    }
    return <LoadSvgIcon component={PayToIcon} {...props} />;
  } else if (type === 'newCard') {
    if (theme === 'dark') {
      return <LoadSvgIcon component={AddCardWhite} {...props} />;
    }
    return <LoadSvgIcon component={AddCard} {...props} />;
  } else if (type === 'newBank' || type === 'BANK') {
    if (theme === 'dark') {
      return <LoadSvgIcon component={AddBankWhite} {...props} />;
    }
    return <LoadSvgIcon component={AddBank} {...props} />;
  } else if (type === 'connectedAccount') {
    return (
      <LoadSvgIcon
        component={AdmiinLogo}
        {...props}
        fill={theme === 'dark' ? 'white' : 'black'}
      />
    );
  } else return null;
}

export default CreditCardIcon;
